import { render } from "./Logs.vue?vue&type=template&id=19c5b69f"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/Modules/Logs/Logs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19c5b69f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19c5b69f', __exports__)) {
    api.reload('19c5b69f', __exports__)
  }
  
  module.hot.accept("./Logs.vue?vue&type=template&id=19c5b69f", () => {
    api.rerender('19c5b69f', render)
  })

}


export default __exports__